(() => {

/**
 * Footnote Linking
 * Links <sup> tags in content to footnote list items and vice versa
 * Uses data-smartscroll for smooth scrolling (handled by smart-scroll.js)
 */ class $6951ff7f39a05d04$var$Footnotes {
    constructor(){
        this.init();
    }
    init() {
        const richText = document.querySelector('.article-content .rich-text');
        const footnotesList = document.querySelector('.article-content ol');
        if (!richText || !footnotesList) return;
        const firstRefs = {}; // Track first reference per footnote number
        // Process <sup> tags: wrap in links and track first occurrence
        richText.querySelectorAll('sup').forEach((sup)=>{
            const num = parseInt(sup.textContent.trim(), 10);
            if (!num) return;
            const link = document.createElement('a');
            link.href = `#footnote-${num}`;
            link.className = 'footnote-link';
            link.setAttribute('aria-label', `Footnote ${num}`);
            sup.parentNode.replaceChild(link, sup);
            link.appendChild(sup);
            // Track first reference for back link
            if (!firstRefs[num]) {
                firstRefs[num] = link;
                link.id = `footnote-ref-${num}`;
            }
        });
    }
}
// Initialize on DOM ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    window.footnotes = new $6951ff7f39a05d04$var$Footnotes();
});
else window.footnotes = new $6951ff7f39a05d04$var$Footnotes();
var $6951ff7f39a05d04$export$2e2bcd8739ae039 = $6951ff7f39a05d04$var$Footnotes;


const $495ea9815b126106$var$FROM_SIDEBAR_KEY = 'from-sidebar';
const $495ea9815b126106$var$FROM_SIDEBAR_GRACE_MS = 500;
/**
 * Dims sidebar elements when user scrolls down
 * Elements with [data-scroll-dim] will get dimmer after scrolling past threshold
 */ class $495ea9815b126106$var$ScrollDim {
    constructor(){
        this.container = document.querySelector('.entry-layout');
        if (!this.container) return;
        this.scrollThreshold = 50; // Start dimming after 50px scroll
        this.isScrolled = false;
        this.init();
    }
    init() {
        // Track Index sidebar link clicks so we can show full opacity after navigation
        const sidebar = document.getElementById('sidebar');
        if (sidebar) sidebar.addEventListener('click', (e)=>{
            const link = e.target.closest('a[href]');
            if (link && link.hostname === window.location.hostname) sessionStorage.setItem($495ea9815b126106$var$FROM_SIDEBAR_KEY, '1');
        }, true);
        // If we navigated from a sidebar link, force full opacity briefly to avoid
        // jank (Safari won't apply :hover to fresh DOM; others may flash dim→bright)
        if (sessionStorage.getItem($495ea9815b126106$var$FROM_SIDEBAR_KEY)) {
            this.container.classList.add('from-sidebar-nav');
            sessionStorage.removeItem($495ea9815b126106$var$FROM_SIDEBAR_KEY);
            setTimeout(()=>{
                this.container.classList.remove('from-sidebar-nav');
            }, $495ea9815b126106$var$FROM_SIDEBAR_GRACE_MS);
        }
        window.addEventListener('scroll', ()=>this.handleScroll(), {
            passive: true
        });
        this.handleScroll(); // Check initial state
    }
    handleScroll() {
        const distanceFromTop = window.scrollY;
        const distanceFromBottom = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
        // Show dimmed state only when past top threshold AND not near bottom
        const scrolled = distanceFromTop > this.scrollThreshold && distanceFromBottom > this.scrollThreshold;
        if (scrolled !== this.isScrolled) {
            this.isScrolled = scrolled;
            this.container.classList.toggle('is-scrolled', scrolled);
        }
    }
}
// Initialize when DOM is ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>new $495ea9815b126106$var$ScrollDim());
else new $495ea9815b126106$var$ScrollDim();


class $eedd4cc3df0e9dbb$var$SidebarGradient {
    constructor(){
        this.scrollContainer = document.getElementById('sidebar-scroll');
        this.gradient = document.getElementById('sidebar-gradient');
        if (!this.scrollContainer || !this.gradient) return;
        this.threshold = 100; // pixels from bottom to start hiding
        this.init();
    }
    init() {
        // Check initial state
        this.updateGradient();
        // Listen for scroll events
        this.scrollContainer.addEventListener('scroll', ()=>this.updateGradient());
        // Listen for resize events (content might change overflow state)
        window.addEventListener('resize', ()=>this.updateGradient());
    }
    updateGradient() {
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = this.scrollContainer;
        const hasOverflow = scrollHeight > clientHeight;
        const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
        // Hide gradient if no overflow, or if scrolled near bottom
        if (!hasOverflow || distanceFromBottom < this.threshold) this.gradient.style.opacity = '0';
        else this.gradient.style.opacity = '1';
    }
}
// Initialize when DOM is ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    new $eedd4cc3df0e9dbb$var$SidebarGradient();
});
else new $eedd4cc3df0e9dbb$var$SidebarGradient();


console.log('Whole Earth Redux');


/**
 * Reading Mode Toggle
 * Supports: light, dark, system (default)
 */ class $06c8b4afaae804b8$var$ReadingMode {
    constructor(){
        this.storageKey = 'reading-mode';
        this.modes = [
            'light',
            'dark',
            'system'
        ];
        this.currentMode = this.getStoredMode() || 'system';
        this.init();
    }
    init() {
        // Apply the stored mode on page load
        this.applyMode(this.currentMode);
        // Listen for system preference changes
        if (window.matchMedia) {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            mediaQuery.addEventListener('change', ()=>{
                if (this.currentMode === 'system') this.applyMode('system');
            });
        }
        // Setup dropdown
        this.setupDropdown();
    }
    getStoredMode() {
        try {
            return localStorage.getItem(this.storageKey);
        } catch (e) {
            return null;
        }
    }
    setStoredMode(mode) {
        try {
            localStorage.setItem(this.storageKey, mode);
        } catch (e) {
        // Ignore storage errors
        }
    }
    getSystemPreference() {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
        return 'light';
    }
    applyMode(mode) {
        const root = document.documentElement;
        // Remove all theme classes
        root.removeAttribute('data-theme');
        root.classList.remove('dark', 'light');
        if (mode === 'system') {
            const systemPref = this.getSystemPreference();
            if (systemPref === 'dark') {
                root.setAttribute('data-theme', 'dark');
                root.classList.add('dark');
            } else {
                root.setAttribute('data-theme', 'light');
                root.classList.add('light');
            }
        } else {
            root.setAttribute('data-theme', mode);
            root.classList.add(mode);
        }
    }
    setMode(mode) {
        if (!this.modes.includes(mode)) return;
        this.currentMode = mode;
        this.setStoredMode(mode);
        this.applyMode(mode);
        this.updateDropdown();
    }
    setupDropdown() {
        const select = document.getElementById('reading-mode-select');
        if (!select) return;
        // Set initial value from stored preference
        select.value = this.currentMode;
        // Listen for changes
        select.addEventListener('change', (e)=>{
            this.setMode(e.target.value);
        });
    }
    updateDropdown() {
        const select = document.getElementById('reading-mode-select');
        if (select) select.value = this.currentMode;
    }
}
// Initialize on DOM ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    window.readingMode = new $06c8b4afaae804b8$var$ReadingMode();
});
else window.readingMode = new $06c8b4afaae804b8$var$ReadingMode();
var $06c8b4afaae804b8$export$2e2bcd8739ae039 = $06c8b4afaae804b8$var$ReadingMode;


/**
 * Smart Scroll
 * Two-step scroll animation: jump near target, then animate the final distance
 * Use data-smartscroll attribute on anchor elements linking to page anchors
 * Optional: data-smartscroll-offset="100" to set custom offset
 */ class $561af99f9444bd08$var$SmartScroll {
    constructor(options = {}){
        this.jumpDistance = options.jumpDistance || 400;
        this.duration = options.duration || 300;
        this.defaultOffset = options.offset || 35;
        this.init();
    }
    /**
   * Check if current scroll position is above the target element
   */ isScrollAboveElement(element) {
        const rect = element.getBoundingClientRect();
        return rect.top > 0;
    }
    /**
   * Animate scroll to a position
   */ animateScrollTo(targetY, duration) {
        return new Promise((resolve)=>{
            const startY = window.scrollY;
            const diff = targetY - startY;
            const startTime = performance.now();
            if (duration === 0) {
                window.scrollTo(0, targetY);
                resolve();
                return;
            }
            const easeOutCubic = (t)=>1 - Math.pow(1 - t, 3);
            const step = (currentTime)=>{
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const eased = easeOutCubic(progress);
                window.scrollTo(0, startY + diff * eased);
                if (progress < 1) requestAnimationFrame(step);
                else resolve();
            };
            requestAnimationFrame(step);
        });
    }
    /**
   * Smart scroll: jump near element, then animate the final distance
   */ scrollTo(element, offset = this.defaultOffset) {
        const rect = element.getBoundingClientRect();
        const elementY = window.scrollY + rect.top - offset;
        const jumpDistance = this.isScrollAboveElement(element) ? -this.jumpDistance : this.jumpDistance;
        const jumpY = elementY + jumpDistance;
        // First: instant jump to position near element
        this.animateScrollTo(jumpY, 0).then(()=>{
            // Then: smooth scroll the final distance
            this.animateScrollTo(elementY, this.duration);
        });
    }
    /**
   * Initialize delegated event listener
   */ init() {
        document.addEventListener('click', (e)=>{
            // Find closest anchor with data-smartscroll attribute
            const link = e.target.closest('a[data-smartscroll]');
            if (!link) return;
            const href = link.getAttribute('href');
            if (!href || !href.startsWith('#')) return;
            const targetId = href.slice(1);
            const target = document.getElementById(targetId);
            if (!target) return;
            e.preventDefault();
            // Get optional offset from data attribute
            const offset = parseInt(link.dataset.smartscrollOffset, 10) || this.defaultOffset;
            this.scrollTo(target, offset);
            history.pushState(null, '', href);
        });
    }
}
// Initialize on DOM ready
let $561af99f9444bd08$var$smartScrollInstance;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    $561af99f9444bd08$var$smartScrollInstance = new $561af99f9444bd08$var$SmartScroll();
});
else $561af99f9444bd08$var$smartScrollInstance = new $561af99f9444bd08$var$SmartScroll();
var $561af99f9444bd08$export$2e2bcd8739ae039 = $561af99f9444bd08$var$SmartScroll;



})();
//# sourceMappingURL=bundle.js.map
